import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    let _this = this;
    setTimeout(function() {
      this.carousel = new Glide(`.c-main-car-carousel`, {
        rewind: false,
        centeredSlides: false,
        centerInsufficientSlides: false,
        centeredSlidesBounds: false,
        perView: 6
      }).mount()

      let swiper = new Swiper('.swiper-container', {
        spaceBetween: 0,
        slidesPerView: 'auto',
        centeredSlides: false,
        centerInsufficientSlides: false,
        centeredSlidesBounds: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }, 400);
  }

  disconnect() {
    this.carousel.destroy();
  }
}